import { Injectable } from "@angular/core";
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { DPO_CONSTANT } from '../utils/constant';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

// Excel Service to handle the creation, read, write of the excel file
@Injectable()
export class ExcelService {

    constructor() { }

    // Method to read a excel file
    public read(dataToProcess: any): any {
        return new Observable((observer) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => {
                const data = new Uint8Array(dataToProcess);
                let arr = new Array();
                for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
                let bstr = arr.join("");
                const workbook = XLSX.read(bstr, { type: "binary" });
                const first_sheet_name = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[first_sheet_name];
                const rowsData = (XLSX.utils.sheet_to_json(worksheet, { header: 1 }));
                observer.next(rowsData);
            }
            fileReader.readAsArrayBuffer(new Blob());
        });
    }

    // Method to write a data to excel file
    public write(dataToProcess: any): any {
        return new Observable((observer) => {
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToProcess);
            const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelFile: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            observer.next(excelFile);
        })
    }

    // Method to save a excel file
    public save(dataToProcess: any, fileName: string): any {
        const data: Blob = new Blob([dataToProcess], { type: EXCEL_TYPE });
        saveAs(data, fileName + '_export_' + new Date().getTime() + DPO_CONSTANT.EXCEL_FILE_EXTENSION);
    }
}